import React from 'react'

import useMediaQuery from './mediaQuery';
import { Link } from 'react-router-dom'

import {
    Grid, Button, Drawer, List, ListItem, ListItemText,
  } from '@material-ui/core';

import { LinkItem, Divider} from './styled'

import Icon from 'react-web-vector-icons';

import logo from '../../images/home/logo.png'

export default ({ language }) => {
    const { large } = useMediaQuery();
  
    const [state, setState] = React.useState({
      left: false,
    });

    if (large) {
      return (
          <nav>
            <Link to="/" style={{ textDecoration: 'none' }}>
              <LinkItem size="22px" borderText>Home</LinkItem>
            </Link>
            <Link to="/quem-somos" style={{ textDecoration: 'none' }}>
              <LinkItem size="22px" borderLeft="2px solid #fff" borderText>{language === 'br' ? 'Quem somos' : 'About us'}</LinkItem>
            </Link>
            <Link to="/servicos" style={{ textDecoration: 'none' }}>
              <LinkItem size="22px" borderLeft="2px solid #fff" borderText>{language === 'br' ? 'Serviços' : 'Services'}</LinkItem>
            </Link>
            <Link to="/portfolio" style={{ textDecoration: 'none' }}>
              <LinkItem size="22px" borderLeft="2px solid #fff" borderText>{language === 'br' ? 'Portfólio' : 'Portfolio'}</LinkItem>
            </Link>
            <Link to="/contato" style={{ textDecoration: 'none' }}>
              <LinkItem size="22px" borderLeft="2px solid #fff" borderText>{language === 'br' ? 'Contato' : 'Contact us'}</LinkItem>
            </Link>
          </nav>
        )
      }
      else {

        const links = [
          'home',
          language === 'br' ? 'quem-somos' : 'about-us',
          language === 'br' ? 'servicos' : 'services', 
          language === 'br' ? 'portifolio' : 'portfolio',
          language === 'br' ? 'contato' : 'contact-us', 
        ]
        const sideList = side => (
          <div
            role="presentation"
            onClick={toggleDrawer(side, false)}
            onKeyDown={toggleDrawer(side, false)}
            style={{width:'100%', backgroundColor: 'rgb(88, 183, 17)', height: "100vh"}}
          >
            <List>
              <Grid container justify="center" alignItems="center">
                <img src={logo} className="Header-logoMenu" alt=""/>
              </Grid>
              
              

              {links.map((text, index) => {
                return (
                  <ListItem component={Link} to={index === 0 ? '/' : `/${text}`} button key={text} 
                    style={{ backgroundColor: "#22222205", borderTop: "solid",
                     borderTopWidth: 0.5, borderTopColor: "#22222220" 
                    }}
                  >
                    <Divider height="8vh" />
                    <ListItemText primary={text.replace('-', ' ')} style={{ textTransform: 'capitalize', color: '#fff', fontWeight: '1000' }} />
                  </ListItem>
                )
              })}
            </List>
            <Divider />
          </div>
        );
  
        const toggleDrawer = (side, open) => event => {
          if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
          }
      
          setState({ ...state, [side]: open });
        };
      
        return (
          <div>
            <Button onClick={toggleDrawer('left', true)}>
              <Icon name='navicon' font='FontAwesome' size={30} color="#fff" style={{ marginRight: 10 }} />
            </Button>
  
            <Drawer open={state.left} onClose={toggleDrawer('left', false)} classes={{ paper: {width: 30} }}>
              {sideList('left')}
            </Drawer>
          </div>
        )
      }
  }